module.exports = __webpack_public_path__ + "img/actions.987f1191.png";